module.exports = __webpack_public_path__ + "img/collection-engagementRingsCordial@2x.3c0bba5.jpg";